import { Component } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { environment } from '../../../environments/environment';
import { PageTitleComponent } from '../../shared/page-title/page-title.component';
import { SeoService } from 'src/app/shared/services/seo.service';

@Component({
  selector: 'app-about',
  imports: [FaIconComponent, PageTitleComponent],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent {
  protected readonly environment = environment;

  constructor(seoService: SeoService) {
    seoService.markAsLoaded();
  }
}
